import { render, staticRenderFns } from "./fp.vue?vue&type=template&id=479427a8&scoped=true&"
import script from "./fp.vue?vue&type=script&lang=js&"
export * from "./fp.vue?vue&type=script&lang=js&"
import style0 from "./fp.vue?vue&type=style&index=0&id=479427a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479427a8",
  null
  
)

export default component.exports